/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from 'react';
import { Growl } from 'primereact/growl';
import { mostrarMensagemSucesso, mostrarMensagemErro } from '../../shared/getMensagens';
import Vincular from '../../shared/Vincular.jsx';
import vincularLinkGrupo from '../../../../services/tvs/vincular-link-grupo';
import midiaServices from '../../../../services/tvs/midiaServices';

export function VincularGrupo({
    rowSelecionada,
    mensagemToast,
    modalVincularTVAberto,
    setModalVincularTVAberto,    
    dadosGrupo
}) {    
    const [gruposVinculados,setGruposVinculados] = useState([]);
    const [gruposDisponivel,setGruposDisponiveis] = useState([]);    
    const [loadingVincular,setLoadingVincular] = useState(false);
    const [linkEdicao,setLinkEdicao] = useState(null);
    
    const { nome,url,status,Id_doc
    } = rowSelecionada;
    
    useEffect(() => {
        (async () => {
            try {
                if(rowSelecionada.length === undefined) {
                    setLinkEdicao({ nome,
                        url,
                        status,
                        Id_doc
                    });
                    
                    const responseGruposSelecionados = await vincularLinkGrupo.getGruposImagemVinculados(Id_doc);
                    
                    const gruposDisponiveis = dadosGrupo.filter(
                        grupo => !responseGruposSelecionados.map(e => e.idGrupo).includes(grupo.id)); 

                    const gruposAVincular = dadosGrupo.filter(
                        grupo => responseGruposSelecionados.map(e => e.idGrupo).includes(grupo.id) );

                    setGruposVinculados(gruposAVincular);
                    setGruposDisponiveis(gruposDisponiveis);
                }
            } catch (error) {
                mostrarMensagemErro(mensagemToast,'Falha na conexão com a internet, tente novamente!');
            }
        })();
    }, [rowSelecionada]);
    
    const onSubmitVincularGrupos = async (indefinidoRever, grupoNaoVinculados, grupoAVincular) => {
        try{
            setLoadingVincular(true);
           
            const idGruposAVincular = grupoAVincular.map(e => e.id);
            const idGruposANaoVincular = grupoNaoVinculados.map(e => e.id);
           
            await midiaServices.deleteDesvincularImagemIdGrupoId(Id_doc, idGruposANaoVincular);
            await midiaServices.postVincularImagemIdGrupoId(Id_doc, idGruposAVincular);
           
            setLoadingVincular(false);
            setModalVincularTVAberto(false);
            mostrarMensagemSucesso(mensagemToast, 'Vinculos estabelicidos com sucesso.');
        } catch (e) {
            setLoadingVincular(false);
            mostrarMensagemErro(mensagemToast, 'Problema para estabelecer vinculos.');
        }
    };    
   
    return (
        <>
            <Growl ref={mensagemToast} />
            
            <Vincular 
                onSubmitBotaoAcao={onSubmitVincularGrupos}
                setFonte={setGruposDisponiveis} 
                setAlvo={setGruposVinculados} 
                fonteDados={gruposDisponivel} 
                titleModal={'Vincular a grupo de programação'}
                idParaPostDelete ={linkEdicao?.id} 
                fonteTitulo={'Grupos de programação disponiveis'} 
                alvoTitulo={'Vinculado aos grupos'} 
                alvoDados={gruposVinculados} 
                openModal={modalVincularTVAberto} 
                isFetching={loadingVincular}
                setOpenModal={setModalVincularTVAberto}/>
            
        </>
    );
}
